import moment from 'moment-timezone'

import { filter, pipe, pluck, propEq, reduce } from 'ramda'

const getSelected = filter(propEq('selected', true))
const mask = (a, b) => a | b
const reduceDayMask = pipe(
  getSelected,
  pluck('value'),
  reduce(mask, 0)
)

class DontSendBackController {
  /* @ngInject */
  constructor (worker, job, schedule, ReferenceService, $mdDialog, ratingType) {
    this.worker = worker
    this.schedule = schedule || {}
    this.$mdDialog = $mdDialog
    this.showReason = false
    this.isOnShift = false
    this.repost = 0
    this.minStartDate = new Date()
    this.minEndDate = new Date()
    this.jobExternalId
    this.note = ''
    if (ratingType) this.ratingType = ratingType

    ReferenceService.getRatingCategories()
      .then(result => {
        this.ratingCategories = result
      })

    if (job) {
      this.repost = 1
      this.isOnShift = true

      this.timezone = job.timezone
      this.timezoneBrowser = moment.tz.guess()

      this.startDate = moment.tz(this.timezone).add(1, 'days').format()
      let shiftStartMinute = moment.tz((this.schedule.start_date_time || job.start_date || job.startDate), this.timezone).get('minute')
      let shiftStartHour = moment.tz((this.schedule.start_date_time || job.start_date || job.startDate), this.timezone).get('hour')
      this.startTime = moment().tz(this.timezone).add(1, 'days').set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).toDate()
      this.endDate = moment.tz((job.end_date || job.endDate), this.timezone).format()
      let shiftEndMinute = moment.tz((this.schedule.end_date_time || job.end_date || job.endDate), this.timezone).get('minute')
      let shiftEndHour = moment.tz((this.schedule.end_date_time || job.end_date || job.endDate), this.timezone).get('hour')
      this.endTime = moment().tz(this.timezone).set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).toDate()
      if (this.timezone !== this.timezoneBrowser) {
        this.timezoneDisplay = true
      }

      this.needed = 1
      this.title = job.title
      this.days = reduceDayMask(job.days)
      this.jobExternalId = job.external_id
    }
    this.ratingReasons = {}
    this.ratingReasons.bad = [
      { value: 6, description: 'Performance Issues' },
      { value: 5, description: 'Excessive Phone Use' },
      { value: 3, description: 'Attendance/Tardies' },
      { value: 4, description: 'Poor Attitude' },
      { value: 2, description: 'Report Incident' },
      { value: 1, description: 'Poor Work Ethic' },
      { value: 7, description: 'Poor Hygiene' }
    ]

    this.ratingReasons.good = [
      { value: 8, description: 'Strong Work Ethic' },
      { value: 9, description: 'Went Above and Beyond' },
      { value: 10, description: 'Good Attendance' },
      { value: 11, description: 'Attention to details' },
      { value: 12, description: 'Quick Learner' },
      { value: 13, description: 'Helped a coworker' },
      { value: 14, description: 'Good Role Model' },
      { value: 15, description: 'Other' }
    ]
  }

  validateDate () {
    this.errors = []
    let startDate = moment(this.startDate)
    let endDate = moment(this.endDate)
    if (startDate > endDate) {
      this.errors.push('End date is before start date')
      this.jobTimeForm.startDate.$error = {maxdate: true}
      this.jobTimeForm.$invalid = true
    }
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  hide () {
    if (this.repost) {
      const shiftStartMinute = moment.tz(this.startTime, this.timezone).get('minute')
      const shiftStartHour = moment.tz(this.startTime, this.timezone).get('hour')
      const newStartDate = moment.tz(moment(this.startDate).format('YYYY-MM-DD'), this.timezone)
        .set({'hour': shiftStartHour, 'minute': shiftStartMinute, 'second': 0}).format()
      const shiftEndMinute = moment.tz(this.endTime, this.timezone).get('minute')
      const shiftEndHour = moment.tz(this.endTime, this.timezone).get('hour')
      const newEndDate = moment.tz(moment(this.endDate).format('YYYY-MM-DD'), this.timezone)
        .set({'hour': shiftEndHour, 'minute': shiftEndMinute, 'second': 0}).format()
      this.$mdDialog.hide({
        reason: this.ratingCategory.name + ': ' + (this.note || null),
        categoryId: this.ratingCategory.id,
        note: this.note,
        dsbRating: this.ratingCategory.default_rating,
        jobId: this.jobExternalId,
        startDate: newStartDate,
        endDate: newEndDate,
        needed: this.needed,
        timezone: this.timezone,
        days: this.days
      })
    } else {
      this.$mdDialog.hide({
        reason: this.ratingCategory.name + ': ' + (this.note || null),
        categoryId: this.ratingCategory.id,
        note: this.note,
        dsbRating: this.ratingCategory.default_rating,
        jobId: this.jobExternalId
      })
    }
  }

  dontSend (ratingCategoryId) {
    this.showReason = true
    this.reason = ratingCategoryId
    this.ratingCategory = this.getRatingCategory(ratingCategoryId)
  }

  getRatingCategory (id) {
    let categories = this.ratingCategories.filter(c => {
      return c.id === id
    })

    return categories[0]
  }

  renderRepostText () {
    let text
    if (this.repost && this.isOnShift) {
      text = 'Refill their position'
    } else {
      text = "Don't Refill position"
    }

    return text
  }
}

export default DontSendBackController
